<template>
  <b-form-group
    :id="'group' + formGroupId"
    :class="`text-input-group ${requireError ? 'require-field' : ''}`"
    :label-for="formGroupId"
    :label="`${$translate(placeholder)} ${required ? '*' : ''}`"
    :state="!isError"
    :invalid-feedback="errorMessage"
  >
    <div class="wrapper">
      <datetime :ref="formGroupId" v-model="dateValue" :disabled="disabled || viewMode" :type="type" :placeholder="$translate(placeholder)" />
      <b-button
        v-if="dateValue && !(disabled || viewMode)"
        v-b-tooltip.hover
        :title="`${$translate('clear')} ${$translate(placeholder)}`"
        class="edit-btn close float-none ml-2 px-2"
        variant="light"
        @click="removeDateValue"
      >
        <span aria-hidden="true">&times;</span>
      </b-button>
    </div>
    <b-form-text v-if="bottomText">
      {{ bottomText }}
    </b-form-text>
  </b-form-group>
</template>

<script>
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';

export default {
  name: 'DatetimeComponent',
  components: { Datetime },
  props: {
    bottomText: {
      type: String,
      default: '',
    },
    formGroupId: {
      type: String,
      default: 'datetime',
    },
    type: {
      type: String,
      default: 'datetime',
    },
    onChange: {
      type: Function,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    viewMode: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    updateError: {
      type: Function,
      default: () => {},
    },
  },
  data: function () {
    return {
      dateValue: null,
    };
  },
  computed: {
    isError: function () {
      const error = this.error;
      this.updateError(error);
      return error;
    },
    requireError: function () {
      return this.required && !this.dateValue;
    },
  },
  watch: {
    value(newVal) {
      this.dateValue = newVal;
    },
    dateValue(value) {
      this.$emit('input', value);
      if (this.onChange) {
        this.onChange(value);
      }
    },
  },
  mounted() {
    this.dateValue = this.value;
  },
  methods: {
    setFocus() {
      this.$refs[this.formGroupId].$el.focus();
    },
    removeDateValue() {
      this.dateValue = null;
      if (this.onChange) {
        this.onChange(null);
      }
    },
  },
};
</script>

<style scoped>
::v-deep .d-block {
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 8px;
}
::v-deep .d-block.invalid-feedback {
  background: url('../../../../assets/icons/info_warning.svg') no-repeat scroll;
  background-position: left center;
  padding-left: 24px;
  font-size: 14px;
  line-height: 20px;
  margin-top: 8px;
}
::v-deep .vdatetime-input {
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  padding: 12px 40px 12px 12px;
  border: 1px solid #c5d0de;
  border-radius: 4px;
  height: auto;
  background: url('../../../../assets/icons/date.svg') no-repeat scroll;
  background-position: right 14px center;
}
::v-deep .vdatetime-calendar__month__day--selected > span > span,
::v-deep .vdatetime-calendar__month__day--selected:hover > span > span,
::v-deep .vdatetime-popup__header {
  background: #2260ff;
}
::v-deep .vdatetime-year-picker__item--selected,
::v-deep .vdatetime-month-picker__item--selected,
::v-deep .vdatetime-time-picker__item--selected {
  color: #2260ff;
}
::v-deep .vdatetime-calendar__month__weekday > span > span,
::v-deep .vdatetime-calendar__month__day > span > span {
  border-radius: 8px;
}
::v-deep .vdatetime-calendar__navigation {
  margin: 15px 30px;
  padding: 8px;
  width: calc(100% - 60px);
  background: rgba(197, 208, 222, 0.2);
  border-radius: 8px;
  color: #2260ff;
}
::v-deep .vdatetime-calendar__navigation--previous {
  top: 7px;
  left: 8px;
}
::v-deep .vdatetime-calendar__navigation--next {
  top: 7px;
  right: 8px;
}
::v-deep .vdatetime-calendar__navigation--next > svg > path,
::v-deep .vdatetime-calendar__navigation--previous > svg > path {
  stroke: #2260ff;
}
.wrapper {
  display: flex;
}
.text-input-group {
  position: relative;
}
.text-input-group.require-field,
.text-input-group.is-invalid {
  color: #ed3232;
}
</style>
